import type { AskQuestionChatbotAskPostData } from '@/client'
import { create } from 'zustand'

// todo allow for undefined when api does
export type ChatContext = AskQuestionChatbotAskPostData['query']

type ChatContextState = {
  chatContext: ChatContext
  setChatContext: (chatContext: ChatContext) => void
  resetChatContext: () => void
}

export const useChatContextState = create<ChatContextState>((set) => ({
  chatContext: {
    lesson_id: undefined,
    start_slide: undefined,
    end_slide: undefined,
    user_lesson_plan_id: undefined,
  },
  setChatContext: (chatContext) => set({ chatContext }),
  resetChatContext: () =>
    set({
      chatContext: {
        lesson_id: undefined,
        start_slide: undefined,
        end_slide: undefined,
        user_lesson_plan_id: undefined,
      },
    }),
}))
